import { NavLink } from 'react-router-dom';
import { X, Sun, Moon } from 'lucide-react';
import { TIERS, isRouteAllowed } from '../config/tiers';
import { getLocalEarnedMarks, getHighestRank } from '../utils/marks';

const DRAWER_LINKS = [
  { section: 'Kitchen', links: [
    { to: '/',              label: 'Home',          end: true },
    { to: '/inventory',     label: 'Inventory' },
    { to: '/recipes',       label: 'Recipes' },
    { to: '/catalog',       label: 'Catalog' },
    { to: '/shopping-list', label: 'Shopping List' },
  ]},
  { section: 'Nutrition', links: [
    { to: '/meal-planner',    label: 'Meal Plan' },
    { to: '/macro-planner',   label: 'Macros' },
    { to: '/meal-synthesizer',label: 'Synthesizer' },
    { to: '/budget',          label: 'Budget' },
  ]},
  { section: 'Protocol', links: [
    { to: '/biometrics',           label: 'Biometrics' },
    { to: '/workout-protocol',     label: 'Workout' },
    { to: '/calendar',             label: 'Calendar' },
    { to: '/progressive-overload', label: 'Overload' },
  ]},
  { section: 'Community', links: [
    { to: '/community',     label: 'Feed' },
    { to: '/discover',      label: 'Discover' },
    { to: '/community/new', label: 'New Post' },
    { to: '/profile',       label: 'My Profile' },
  ]},
  { section: 'Tools', links: [
    { to: '/fitness',   label: 'Fitness Log' },
    { to: '/brigade',   label: 'Brigade' },
    { to: '/ai-recipe', label: 'Recipe AI' },
    { to: '/blog',      label: 'Protocol Library' },
    { to: '/feedback',  label: 'Feedback' },
    { to: '/upgrade',   label: 'Plans' },
    { to: '/settings',  label: 'Settings' },
  ]},
];

const MobileDrawer = ({ open, onClose, tier, darkMode, setDarkMode }) => {
  const tierConfig = TIERS[tier] || TIERS.commis;
  const earnedIds = getLocalEarnedMarks();
  const rank = getHighestRank(earnedIds);

  if (!open) return null;

  return (
    <>
      <div className="mobile-drawer-backdrop" onClick={onClose} />
      <div className="mobile-drawer" role="dialog" aria-label="Navigation menu" aria-modal="true">
        <div className="mobile-drawer-header">
          <span className="header-monogram" aria-hidden="true">dP</span>
          <span className="mobile-drawer-brand">de Partie</span>
          <button className="mobile-drawer-close" onClick={onClose} aria-label="Close menu">
            <X size={20} aria-hidden="true" />
          </button>
        </div>

        <div className="mobile-drawer-body">
          {DRAWER_LINKS.map(({ section, links }) => (
            <div key={section} className="mobile-drawer-section">
              <div className="mobile-drawer-section-label">{section}</div>
              {links.map(({ to, label, end }) => {
                const allowed = isRouteAllowed(tier, to);
                return (
                  <NavLink
                    key={to}
                    to={to}
                    end={end}
                    className={({ isActive }) =>
                      `mobile-drawer-link${isActive ? ' active' : ''}${!allowed ? ' locked' : ''}`
                    }
                    onClick={onClose}
                  >
                    <span>{label}</span>
                    {!allowed && <span className="nav-lock-badge">PRO</span>}
                  </NavLink>
                );
              })}
            </div>
          ))}
        </div>

        <div className="mobile-drawer-footer">
          <NavLink to="/brigade" className="nav-rank-badge" onClick={onClose}>
            <span className="nav-rank-name">{rank ? rank.name : tierConfig.name}</span>
            <span className="nav-rank-count">{earnedIds.length} marks</span>
          </NavLink>
          <button
            onClick={() => setDarkMode(!darkMode)}
            className="btn-theme-toggle"
            aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            <span>{darkMode ? 'Light Mode' : 'Dark Mode'}</span>
            {darkMode
              ? <Sun size={14} aria-hidden="true" />
              : <Moon size={14} aria-hidden="true" />
            }
          </button>
        </div>
      </div>
    </>
  );
};

export default MobileDrawer;
